const slaCostCenter = {
  slaHeader: {
    'Vehicle Name': 'vehicle_short_form',
    Movement: 'movement',
    'Depot REF ID': 'ref_id',
    'Acceptance cost': 'acceptance_delay_cost',
    'Assignment cost': 'assignment_delay_cost',
    'Arrival Cost': 'arrival_delay_cost',
    'Rejection Cost': 'rejection_cost',
    'Grace Period': 'grace_period',
  },
  nonMandatoryHeaders: {
    'Max Arrival SLA(%)': 'max_arrival_sla',
  },
};
module.exports = { slaCostCenter };
